import { useState } from 'react';

interface FormHeaderProps {
  logoUrl?: string;
  formName?: string;
  alignment?: 'left' | 'center' | 'right';
}

export function FormHeader({ logoUrl, formName, alignment = 'center' }: FormHeaderProps) {
  const [imageError, setImageError] = useState(false);

  if (!logoUrl || imageError) {
    return null;
  }

  const alignmentClass =
    alignment === 'center'
      ? 'text-center'
      : alignment === 'right'
        ? 'text-right'
        : 'text-left';
  const logoAlignmentClass =
    alignment === 'center' ? 'mx-auto' : alignment === 'right' ? 'ml-auto' : '';

  return (
    <div className={`form-header mb-8 ${alignmentClass}`}>
      <img
        src={logoUrl}
        alt={formName ? `${formName} logo` : 'Form logo'}
        className={`max-w-[200px] max-h-[80px] object-contain ${logoAlignmentClass}`}
        onError={() => setImageError(true)}
        loading="eager"
      />
    </div>
  );
}
